import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActivityFeedItem = ({ activity }) => {
  const getActivityIcon = (type) => {
    const icons = {
      bid: 'FileText',
      project: 'Briefcase',
      resource: 'Package',
      milestone: 'CheckCircle',
      customer: 'Users'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      bid: 'bg-accent/10 text-accent',
      project: 'bg-primary/10 text-primary',
      resource: 'bg-warning/10 text-warning',
      milestone: 'bg-success/10 text-success',
      customer: 'bg-secondary/10 text-secondary'
    };
    return colors?.[type] || 'bg-muted text-muted-foreground';
  };

  const formatTimestamp = (date) => {
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);
    
    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  };

  return (
    <div className="flex gap-3 md:gap-4 p-3 md:p-4 hover:bg-muted/50 rounded-lg transition-colors duration-250">
      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${getActivityColor(activity?.type)} flex items-center justify-center flex-shrink-0`}>
        <Icon name={getActivityIcon(activity?.type)} size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <p className="text-sm md:text-base text-foreground font-medium line-clamp-2">{activity?.title}</p>
          <span className="text-xs text-muted-foreground whitespace-nowrap">{formatTimestamp(activity?.timestamp)}</span>
        </div>
        <p className="text-xs md:text-sm text-muted-foreground line-clamp-2 mb-2">{activity?.description}</p>
        <div className="flex items-center gap-2">
          <Image 
            src={activity?.userAvatar} 
            alt={activity?.userAvatarAlt}
            className="w-6 h-6 rounded-full object-cover"
          />
          <span className="text-xs text-muted-foreground">{activity?.userName}</span>
        </div>
      </div>
    </div>
  );
};

export default ActivityFeedItem;